import React, { useState, useEffect, useRef } from "react";

import { Button, Form, Row, Col } from "react-bootstrap";

import Modal from "react-bootstrap/Modal";

import {
   BarChart,
   Bar,
   XAxis,
   YAxis,
   Tooltip,
   Legend,
   ResponsiveContainer,
} from "recharts";

const initalEinkaufValues = [{ name: "" }];
export default function NutzergrafikEinkauf({
   users,
   einkaufstermine
}) {
   const [ektData, setEktData] = useState();
   const [graphData, setGraphData] = useState(initalEinkaufValues);


   useEffect(() => {
      if (einkaufstermine&& users) {
         const heute = new Date();
         const userdata = {};

         einkaufstermine.filter(item=>item.benutzer).forEach((item) => {
            const parsedDatum = new Date(item.datum);
            // let monat = parsedDatum.getMonth();
            if(item.benutzer===undefined){
               console.log(item);
            }
            let itemuser = item.benutzer.id;
            

            if (!userdata[itemuser]) {
               userdata[itemuser] = { past: [], future: [] };
            }

            if (parsedDatum < heute) {
               userdata[itemuser].past.push(item);
            } else {
               userdata[itemuser].future.push(item);
            }
         });

         console.log(userdata);

         setEktData(userdata);
      }
   }, [einkaufstermine,users]);

   useEffect(() => {
      if (ektData) {
         setGraphData(
            Object.keys(ektData).map((item) => ({
              ["name"]: users[item]?users[item].Name:item,
               ["EK (vergangen)"]: ektData[item].past.length,
               ["EK (offen)"]: ektData[item].future.length,
            }))
         );
      }
   }, [ektData]);

   

   function renderCustomBarLabel({ payload, x, y, width, height, value, altLabel, isCurrency }) {
      return (
         <text x={x + width / 2} y={y} fill="#eef" fontWeight={500} textAnchor="middle" dy={-7}>
            {isCurrency ? (
               <tspan textAnchor="middle">
                  {new Intl.NumberFormat("de-DE", {
                     style: "currency",
                     currency: "EUR",
                     maximumFractionDigits: 0,
                  }).format(value)}
               </tspan>
            ) : (
               <tspan textAnchor="middle">{value ? value : ""}</tspan>
            )}
            {altLabel && (
               <tspan textAnchor="middle" x={x + width / 2} y={y - 24}>
                  {altLabel}
               </tspan>
            )}
         </text>
      );
   }

   return (
      <div className="projektstatus-l2 projektstatus-statistik">
         <div
            style={{
               margin: "auto",
               minWidth: "100%",
               maxWidth: "100vw",
            }}
         >
            <div>
               <h2 style={{ backgroundColor: "#0004", margin: 0, paddingTop: "8px" }}> {einkaufstermine.length} Einkaufstermine</h2>
               <ResponsiveContainer
                  style={{ background: "linear-gradient(180deg, #0004 0%, #0000 100%)" }}
                  width={"100%"}
                  height={300}
               >
                  <BarChart
                     data={graphData}
                     margin={{
                        top: 30,
                        right: 0,
                        left: 0,
                        bottom: 5,
                     }}
                  >
                     <XAxis dataKey="name" type="category" tick={{ fill: "#eef", fontSize: "x-small" }} />
                     <YAxis type="number" tick={{ fill: "#eef", fontSize: "small" }} />
<Tooltip/>
                     <Legend /* content={(e)=>renderCustomLabel({...e})} */ />

                     <Bar dataKey="EK (vergangen)" fill="#8EA7E9" label={renderCustomBarLabel} />
                     <Bar dataKey="EK (offen)" fill="#E5E0FF" label={renderCustomBarLabel} />
                    
                  </BarChart>
               </ResponsiveContainer>
            </div>
         </div>
      </div>
   );
}
